import { __awaiter, __generator, __read, __values } from "tslib";
import { createContext } from './query-job';
import BinarySearch from '../algorithm/binary-search';
var QueryJobIntersect = /** @class */ (function () {
    function QueryJobIntersect(node, parent) {
        this.node = node;
        this.parent = parent;
        this.context = createContext(node);
    }
    /**
     * Get the intersection of all inputs(a bunch of DataPointer[]),
     * the output order is identical to the smallest input pointers
     */
    QueryJobIntersect.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, context, node, inputs, comparer, searcher, smallestPointers, inputs_1, inputs_1_1, pointers_1, isAppearedAllInputs, pointers;
            var e_1, _b;
            return __generator(this, function (_c) {
                _a = this, context = _a.context, node = _a.node;
                inputs = context.inputs;
                if (!inputs.length)
                    return [2 /*return*/];
                if (inputs.length === 1) {
                    output.push(inputs[0]);
                    return [2 /*return*/];
                }
                comparer = function (_a, _b) {
                    var _c = __read(_a, 1), kx = _c[0];
                    var _d = __read(_b, 1), ky = _d[0];
                    return node.comparer.cmp(kx, ky);
                };
                searcher = new BinarySearch({ cmp: comparer });
                smallestPointers = this.getSmallestPointers(inputs).slice();
                try {
                    for (inputs_1 = __values(inputs), inputs_1_1 = inputs_1.next(); !inputs_1_1.done; inputs_1_1 = inputs_1.next()) {
                        pointers_1 = inputs_1_1.value;
                        // Sort all inputs by key
                        pointers_1.sort(comparer);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (inputs_1_1 && !inputs_1_1.done && (_b = inputs_1.return)) _b.call(inputs_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                isAppearedAllInputs = function (pointer) {
                    return inputs.every(function (pointers) { return searcher.has(pointers, pointer); });
                };
                pointers = smallestPointers.filter(isAppearedAllInputs);
                output.push(pointers);
                return [2 /*return*/];
            });
        });
    };
    QueryJobIntersect.prototype.getSmallestPointers = function (inputs) {
        return inputs.reduce(function (smallest, pointers) { return (smallest.length < pointers.length ? smallest : pointers); }, this.context.inputs[0]);
    };
    return QueryJobIntersect;
}());
export { QueryJobIntersect };
export default QueryJobIntersect;
//# sourceMappingURL=query-job-intersect.js.map